import React, { Component } from 'react'
import Axios from '../../../config/axios'
import withErrorHandler from 'hoc/withErrorHandler'
import { Card, Input, Col, Button, Row, PageHeader } from 'antd'
import Loading from 'components/Loading'

class CreateLeaflet extends Component {

    state = {
        leaflet: {
            template: '',
            title: '',
            fields: []
        },
        file:{},
        form:{}
    }

    componentDidMount() {
        this.fetchLeaflet()
    }

    fetchLeaflet = () => {
        Axios.get("/leaflets/"+this.props.match.params.id).then(response => {
            this.setState({ leaflet: response.data })
        })
    }

    generatePdf = () => {
        Axios.post("/leaflets/generate/"+this.props.match.params.id, this.state.form).then(response => {
            this.setState({ file: response.data })
        })
    }

    handleChangeForm = (e) => {
        let {form} = this.state
        form[e.target.name] = e.target.value
        this.setState({ form })
    }

    render(){             
        return(
            <div>
                 <div className="site-layout-background" style={{ padding: 10 }}>
                    <PageHeader
                        className="site-page-header"
                        onBack={() => this.props.history.push({
                            pathname : '/admin/edaran'                           
                        })}                        
                        title="Surat Edaran"
                        subTitle="Buat surat Edaran"                       
                    />                  
                </div>            
            <Col md={8}>
                <Card
                    title="Isi Form untuk membuat file"
                    style={{marginTop:20}}
                >
                     {
                         this.state.leaflet.fields.map((field, index) => 
                            <Input
                                key={index}
                                placeholder={field.placeholder}
                                name={field.name}
                                style={{marginBottom:10}}
                                value={this.state.form[field.name] || ''}
                                onChange={this.handleChangeForm}
                            />    
                        )
                     }
                    <Row>
                        <Button type="primary" onClick={this.generatePdf}>Buat Surat Edaran</Button>
                        {
                            this.state.file.dir ?
                            <a href={this.state.file.dir} target="_blank" rel="noopener noreferrer" style={{marginLeft:10}}>
                                <Button>Download</Button>
                            </a>:null
                        }
                        
                    </Row>
                    
                </Card>   

                <Loading loading={this.props.loading} />
            </Col>
        </div>
        )
    }
}

export default withErrorHandler(CreateLeaflet, Axios)